export default "__VITE_ASSET__XMypqwYe__"